var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.label
      ? _c("p", { staticClass: "global-navi-title" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm.separator
      ? _c("p", { staticClass: "global-navi-title global-navi-separator" })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      [
        _vm._l(_vm.mainMenuItems, function (menuItem) {
          return _c(
            "li",
            { key: menuItem.label },
            [
              _c(menuItem, {
                ref: menuItem.name,
                refInFor: true,
                tag: "component",
                attrs: { active: _vm.active },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.expandable
          ? _c("li", [
              _vm.expanded
                ? _c(
                    "ul",
                    _vm._l(_vm.extraMenuItems, function (menuItem) {
                      return _c(
                        "li",
                        { key: menuItem.label },
                        [
                          _c(menuItem, {
                            ref: menuItem.name,
                            refInFor: true,
                            tag: "component",
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.expanded
                ? _c(
                    "a",
                    {
                      staticClass:
                        "global-navi-btn-accordion global-navi-arrow-accordion-close",
                      on: {
                        click: function ($event) {
                          _vm.expanded = false
                        },
                      },
                    },
                    [_vm._v("メニューを閉じる")]
                  )
                : _c(
                    "a",
                    {
                      staticClass:
                        "global-navi-btn-accordion global-navi-arrow-accordion-open",
                      on: {
                        click: function ($event) {
                          _vm.expanded = true
                        },
                      },
                    },
                    [_vm._v("メニューをもっとみる")]
                  ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }